module.exports = __webpack_public_path__ + "img/1589007387.dee3e7a8.jpg";